
<template>
   
      <VAvatar
        class="cursor-pointer mr-3"
      >
        <VImg src="/images/loncengicon.png" />
  
        <!-- SECTION Menu -->
        <VMenu
          activator="parent"
          width="400"
          location="bottom end"
          offset="14px"
        >
          <VList>
          

             <VListItem to="/login">
             
              <VListItemTitle> Notifikasi Pelatihan Belum Tersedia</VListItemTitle>
            </VListItem>
          </VList>
        </VMenu>
      </VAvatar>
  </template>